import request from '@/utils/request.js'

// 外呼学员列表
function userList(data) {
    return request({
        url: '/api/v1/tob/crm/users',
        method: 'get',
        params:data
    })
}

// 外呼学员更新
function updateUser(data) {
    return request({
        url: '/api/v1/tob/crm/update',
        method: 'post',
        data
    })
}
// 外呼
function callPhone(data) {
    return request({
        url: '/api/v1/tob/crm/call',
        method: 'post',
        data
    })
}
// 修改员工外呼号码
function updateAccountCallPhone(data) {
    return request({
        url: '/api/v1/tob/accounts/edit/call',
        method: 'post',
        data
    })
}

// 导入外呼号码
function importCallPhone(data) {
    return request({
        url: '/api/v1/tob/crm/import',
        method: 'post',
        data
    })
}

// 外呼状态轮询
function callStatusQuery(data) {
    return request({
        url: '/api/v1/tob/crm/callstatus',
        method: 'get',
        params:data
    })
}
// 外呼扣费记录
function callOrders(data) {
    return request({
        url: '/api/v1/tob/crm/orders',
        method: 'get',
        params:data
    })
}

// 导入详情记录
function getImportDetalRecord(data) {
    return request({
        url: '/api/v1/tob/importdetail',
        method: 'get',
        params:data
    })
}

// 获取机构中所有任务 /api/v1/tob/alltask
function getTaskNameData(data) {
    return request({
        url: '/api/v1/tob/alltask',
        method: 'get',
        params:data
    })
}

// 获取编辑数据任务列表/api/v1/tob/taskdata getEditTaskData
function getEditTaskData(data) {
    return request({
        url: '/api/v1/tob/taskdata',
        method: 'get',
        params:data
    })
}

// 修改单个任务名称 /api/v1/tob/edittaskname submitChangeTaskName
function submitChangeTaskName(data) {
    return request({
        url: '/api/v1/tob/edittaskname',
        method: 'post',
        data
    })
}

// 删除任务下的某条导入数据 /api/v1/tob/delallotdata deleteSingleTask
function deleteSingleTask(data) {
    return request({
        url: '/api/v1/tob/delallotdata',
        method: 'post',
        data
    })
}

// 机构-任务执行概况 getStaffProgress /api/v1/tob/tasktongji
function getStaffProgress(data) {
    return request({
        url: '/api/v1/tob/tasktongji',
        method: 'get',
        params:data
    })
}
 
// taskUserDo 任务客户数据添加/修改
function taskUserDo(data) {
    return request({
        url: '/api/v1/tob/taskuserdo',
        method: 'post',
        data
    })
}

function getTobCrmLog(data) {
    return request({
        url: '/api/v1/tob/crmlog',
        method: 'get',
        params:data
    })
}

// 外呼用户总数（未联系/未接通）/api/v1/tob/crm/get-user-count
function getUserCount(data) {
    return request({
        url: '/api/v1/tob/crm/get-user-count',
        method: 'get',
        params:data
    })
}


// 批量操作外呼用户 /api/v1/tob/crm/batch-user
function batchUser(data) {
    return request({
        url: '/api/v1/tob/crm/batch-user',
        method: 'post',
        data
    })
}

export default{
    userList,
    updateUser,
    callPhone,
    updateAccountCallPhone,
    importCallPhone,
    callStatusQuery,
    callOrders,
    getImportDetalRecord,
    getTaskNameData,
    getEditTaskData,
    submitChangeTaskName,
    deleteSingleTask, 
    getStaffProgress,
    taskUserDo,
    getTobCrmLog,
    getUserCount,
    batchUser
}
